import * as React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { fetchAutosuggestAction, saveAutosuggestItemAction, initAutoSuggestAction, savePlainQueryItemAction } from 'actions/AutosuggestActions/AutosuggestActions';
import getAbValueAction from 'actions/abExperimentsActions';
import { ContentType } from 'actions/AutosuggestActions/Utils';
import debounce from 'lodash/debounce';
import { safeTrim, decodeQuery } from 'utils/stringUtils';
import { routeHandler } from 'utils/routeHandler';
import keyCodes from 'utils/keyCodes';
import cx from 'classnames';
import { withRouter } from 'react-router';
import { SearchIcon } from 'components/Icons/Icons';
import { stringTemplate } from 'components/StringWidget/StringWidget';
import defaultStyles from './Search.css';
import templatesStyles from './itemTemplates.css';
import offersStoreStyles from './offersStore.Search.css';
import itzcashStoreStyles from './itzcashStore.Search.css';
import indusindStoreStyles from './indusindStore.Search.css';
import yahooStoreStyles from './yahooStore.Search.css';
import axisStoreStyles from './axisStore.Search.css';
import * as SuggestionTemplates from './itemTemplates';
import groceryStyles from './grocery.css';
import { MarketplaceId } from '@rome/request/marketplace/MarketplaceId';
import { WidgetTypeV4 } from '@rome/response/page/v4/WidgetTypeV4';
import fdpHelper from 'utils/FDPHelper';
import AutosuggestTrackableTemplate from './AutosuggestTrackableTemplate';
import LinkMaybe from 'components/LinkMaybe/LinkMaybe';
const newNavigationContext = function () {
    const ssid = fdpHelper.generateId();
    return { ssid };
};
var TEXT_INPUT_EVENTS;
(function (TEXT_INPUT_EVENTS) {
    TEXT_INPUT_EVENTS[TEXT_INPUT_EVENTS["SEARCH_BOX_CLICK"] = 1] = "SEARCH_BOX_CLICK";
    TEXT_INPUT_EVENTS[TEXT_INPUT_EVENTS["DIRECT_SEARCH"] = 2] = "DIRECT_SEARCH";
    TEXT_INPUT_EVENTS[TEXT_INPUT_EVENTS["AUTO_SUGGEST_CLICK"] = 3] = "AUTO_SUGGEST_CLICK";
    TEXT_INPUT_EVENTS[TEXT_INPUT_EVENTS["FOCUS_CHANGE"] = 4] = "FOCUS_CHANGE";
    TEXT_INPUT_EVENTS[TEXT_INPUT_EVENTS["TEXT_INPUT_UPDATE"] = 5] = "TEXT_INPUT_UPDATE";
})(TEXT_INPUT_EVENTS || (TEXT_INPUT_EVENTS = {}));
const fetchDebounceTime = 250;
const trackextInputUpdate = debounce((searchTxt, ssid) => {
    fdpHelper.trackEvent({
        en: 'TIE',
        tp: 'search_autosuggest',
        iid: ssid,
        te: searchTxt,
        ua: TEXT_INPUT_EVENTS.TEXT_INPUT_UPDATE
    });
}, fetchDebounceTime);
const trackSearchBoxClick = (searchTxt, ssid) => {
    fdpHelper.trackEvent({
        en: 'TIE',
        tp: 'search_autosuggest',
        iid: ssid,
        te: searchTxt,
        ua: TEXT_INPUT_EVENTS.SEARCH_BOX_CLICK
    });
};
const trackFocusChangeClick = (searchTxt, ssid) => {
    fdpHelper.trackEvent({
        en: 'TIE',
        tp: 'search_autosuggest',
        iid: ssid,
        te: searchTxt,
        ua: TEXT_INPUT_EVENTS.FOCUS_CHANGE
    });
};
const trackDirectSearchClick = (searchTxt, ssid) => {
    fdpHelper.trackEvent({
        en: 'TIE',
        tp: 'search_autosuggest',
        iid: ssid,
        te: searchTxt,
        ua: TEXT_INPUT_EVENTS.DIRECT_SEARCH
    });
};
const trackAutosuggestClick = (searchTxt, ssid) => {
    fdpHelper.trackEvent({
        en: 'TIE',
        tp: 'search_autosuggest',
        iid: ssid,
        te: searchTxt,
        ua: TEXT_INPUT_EVENTS.AUTO_SUGGEST_CLICK
    });
};
export class Search extends React.Component {
    constructor(props) {
        super(props);
        this.fetchAutoSuggestion = (currentValue, prevValue) => {
            if (currentValue !== prevValue || currentValue === '') {
                const { location, isGrocery } = this.props;
                const marketplace = isGrocery ? MarketplaceId.GROCERY : MarketplaceId.FLIPKART;
                const currentUri = location.pathname + location.search;
                const noASCache = this.props.noASCacheGlobalConfigFlag || this.props.getAbValue('noASCache', false);
                this.props.fetchAutosuggest(currentValue, marketplace, currentUri, noASCache);
            }
        };
        this.handleKeyUp = (e, count) => {
            if (this.state.autosuggestVisible && (e.keyCode === keyCodes.up || e.keyCode === keyCodes.down)) {
                e.preventDefault();
                const isKeyUp = e.keyCode === keyCodes.up;
                const index = isKeyUp ? this.state.highlightIndex - 1 : this.state.highlightIndex + 1;
                let highlightIndex = index >= count ? count - 1 : index < 0 ? 0 : index;
                const highlightedItem = get(this.storeData, [highlightIndex, 'value']);
                if (!highlightedItem)
                    return;
                if (highlightedItem.template === WidgetTypeV4.AUTOSUGGEST_PARTITION_WIDGET) {
                    highlightIndex =
                        highlightIndex <= count
                            ? isKeyUp
                                ? highlightIndex - 1
                                : highlightIndex + 1
                            : isKeyUp
                                ? highlightIndex + 1
                                : highlightIndex - 1;
                }
                this[`item_${highlightIndex}`] &&
                    this[`item_${highlightIndex}`].scrollIntoView(isKeyUp && highlightIndex > count / 2);
                const searchText = get(this.storeData, [highlightIndex, 'value', 'backfill']) || this.state.searchTxt;
                this.setState({
                    highlightIndex,
                    searchTxt: searchText
                });
            }
            else if (e.keyCode === keyCodes.enter && this.state.highlightIndex >= 0) {
                e.preventDefault();
                this.txt_q && this.txt_q.blur();
                const store = get(this.storeData, [this.state.highlightIndex]);
                if (!store)
                    return;
                const link = `${store.value.navigationUrl}&as-backfill=on`;
                store.value.navigationUrl = link;
                this.onSuggestionSelected(store);
                this.context.router.push(link);
            }
            else if (e.keyCode === keyCodes.esc && this.state.autosuggestVisible) {
                this.setState({
                    autosuggestVisible: false,
                    highlightIndex: -1
                });
            }
            else if (this.state.highlightIndex > -1) {
                this.setState({
                    highlightIndex: -1
                });
            }
        };
        this.handleKeyDown = (e) => {
            if (e &&
                (e.keyCode === keyCodes.up ||
                    e.keyCode === keyCodes.down ||
                    (e.keyCode === keyCodes.enter && (this.state.highlightIndex >= 0 || !safeTrim(this.state.searchTxt))))) {
                e.preventDefault();
            }
        };
        this.handleChange = (e) => {
            const searchTxt = e.target.value;
            const prevSearchTxt = this.state.searchTxt;
            let autosuggestVisible = true;
            const trimmedTxt = safeTrim(searchTxt);
            this.sendFetchSuggestionRequest(trimmedTxt, searchTxt, prevSearchTxt);
            this.setState({ autosuggestVisible, searchTxt });
        };
        this.sendFetchSuggestionRequest = (trimmedTxt, searchTxt, prevSearchTxt) => {
            trimmedTxt.length === 1
                ? this.fetchAutoSuggestion(searchTxt, prevSearchTxt)
                : this.fetchSuggestion(searchTxt, prevSearchTxt);
            trackextInputUpdate(searchTxt, this.ssid);
        };
        this.handleBlur = (e) => {
            setTimeout(() => {
                this.setState({
                    autosuggestVisible: false,
                    highlightIndex: -1
                });
            }, 300);
            trackFocusChangeClick(e.target.value, this.ssid);
        };
        this.handleFocus = (e) => {
            if (!this.state.autosuggestVisible) {
                const searchText = this.state.searchTxt || '';
                this.fetchAutoSuggestion(searchText, '');
                this.setState({
                    autosuggestVisible: true
                });
            }
            trackSearchBoxClick(e.target.value, this.ssid);
        };
        this.handleMouseOver = () => this.state.highlightIndex !== -1 && this.setState({ highlightIndex: -1 });
        this.handleSubmit = (e) => {
            e.preventDefault();
            if (!safeTrim(this.state.searchTxt))
                return;
            const fields = e.target.elements;
            const qParams = {};
            let qParamsString = '';
            // @vkb: This URLSearchParams call is throwing an error:
            // URLSearchParams is not defined in Chrome + Windows. Need to
            // investigate why.
            const queryString = new URLSearchParams();
            Array.prototype.forEach.call(fields, field => {
                if (field.type === 'hidden') {
                    const name = field.getAttribute('name');
                    const value = field.getAttribute('value');
                    qParams[name] = value;
                    queryString.append(name, value);
                }
            });
            qParamsString = queryString.toString();
            const value = (this.txt_q && this.txt_q.value) || null;
            const encodedVal = (value && encodeURIComponent(value)) || null;
            if (encodedVal) {
                const url = `/search?q=${encodedVal}&${qParamsString}`;
                this.props.savePlainQuery(this.state.searchTxt, url, this.getmarketplaceId());
                const pathObject = {
                    pathname: '/search',
                    query: Object.assign({ q: value }, qParams)
                };
                routeHandler(pathObject, this.context);
            }
            this.txt_q && this.txt_q.blur();
            value && trackDirectSearchClick(value, this.ssid);
        };
        this.getmarketplaceId = () => {
            return this.props.isGrocery ? MarketplaceId.GROCERY : MarketplaceId.FLIPKART;
        };
        this.onSuggestionSelected = (item) => {
            if (item.value.template === WidgetTypeV4.AUTOSUGGEST_PARTITION_WIDGET)
                return;
            this.props.saveInHistory(item, item.marketplace);
            if (item.value.contentType !== ContentType.HISTORY && item.value.contentType !== ContentType.TRENDING) {
                this.setState({
                    searchTxt: item.value.title || item.value.query
                });
            }
            trackAutosuggestClick(item.value.title, this.ssid);
        };
        this.inputRef = (c) => (this.txt_q = c);
        this.anchorRef = (count) => (c) => (this[`anchor_${count}`] = c);
        this.itemRef = (count) => (c) => (this[`item_${count}`] = c);
        this.renderItem = (suggestion, index, highlightIndex, styles) => {
            const asSearchText = this.state.searchTxt;
            let responseTimeInMS = get(this.props, ['autosuggest', 'responseTimeInMS']);
            let url = get(suggestion, ['value', 'navigationUrl']) || '';
            if (asSearchText) {
                url = `${url}&as-searchtext=${encodeURI(asSearchText)}`;
            }
            const templateClassName = suggestion && SuggestionTemplates.getTemplateClass(suggestion);
            const trackingDataWithResponseTime = Object.assign(Object.assign({}, suggestion.tracking), { responseTimeInMS });
            return (suggestion && (<li key={index} ref={this.itemRef(index)} className={styles['item']}>
					<AutosuggestTrackableTemplate tracking={trackingDataWithResponseTime} wid="">
						<LinkMaybe onClick={() => (url ? this.onSuggestionSelected(suggestion) : undefined)} to={url} className={cx(templateClassName, {
                [templatesStyles['highlight']]: highlightIndex === index
            })}>
							{SuggestionTemplates.getTemplate(suggestion, asSearchText)}
						</LinkMaybe>
					</AutosuggestTrackableTemplate>
				</li>));
        };
        this.storeData = [];
        this.state = {
            autosuggestVisible: false,
            searchTxt: props.defaultQuery || '',
            highlightIndex: -1
        };
        this.fetchSuggestion = debounce(this.fetchAutoSuggestion, fetchDebounceTime);
        fdpHelper.setNavigationContext(newNavigationContext());
        const ssid = fdpHelper.generateId();
        fdpHelper.setNavigationContext({ ssid });
        this.ssid = ssid;
    }
    componentDidMount() {
        this.props.initAutoSuggest();
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.defaultQuery !== nextProps.defaultQuery) {
            this.setState({ searchTxt: nextProps.defaultQuery });
        }
        const { pathname, search } = this.props.location;
        const { pathname: nextPropsPathName, search: nextPropsSearch } = nextProps.location;
        if ((pathname !== nextPropsPathName || search !== nextPropsSearch) && this.state.autosuggestVisible) {
            this.setState({ autosuggestVisible: false });
        }
    }
    getStyles(isGrocery) {
        const { cobrandedStore } = this.props;
        if (isGrocery) {
            return Object.assign({}, defaultStyles, groceryStyles);
        }
        switch (cobrandedStore) {
            case 'offers':
                return Object.assign({}, defaultStyles, offersStoreStyles);
            case 'itzcash':
                return Object.assign({}, defaultStyles, itzcashStoreStyles);
            case 'indusind':
                return Object.assign({}, defaultStyles, indusindStoreStyles);
            case 'yahoo':
                return Object.assign({}, defaultStyles, yahooStoreStyles);
            case 'axis':
                return Object.assign({}, defaultStyles, axisStoreStyles);
            default:
                return defaultStyles;
        }
    }
    render() {
        const { autosuggest, disableSearch, isGrocery, getAbValue, noASCacheGlobalConfigFlag } = this.props;
        if (disableSearch)
            return null;
        const marketplaceId = this.getmarketplaceId();
        const { highlightIndex, searchTxt, autosuggestVisible } = this.state;
        const hintText = isGrocery ? stringTemplate('grocerySearchBarPlaceHolder') : stringTemplate('searchBarPlaceholder');
        // We encode this value before storing it in the reducer. So since this
        // value is used only for display purposes in the input field in the
        // first page load, we decode this value here.
        // FIXME: relying on the fact that searchTxt being undefined won't
        // update the already present `input` value when set to it seems a bit
        // hacky. Figure out a way to do this better.
        const decodedSearchTxt = searchTxt ? decodeQuery(searchTxt) : searchTxt;
        const styles = this.getStyles(isGrocery);
        const autoSuggestWords = get(autosuggest, ['words']) || {};
        const autoSuggestQuery = get(autosuggest, ['query']) || '';
        this.storeData = autoSuggestWords[`${autoSuggestQuery} - ${marketplaceId}`] || [];
        const historyData = autosuggest.searchHistory || [];
        const noASCache = noASCacheGlobalConfigFlag || getAbValue('noASCache', false);
        /*
            Apparently there's a bug in the below logic, we aren't trimming the string
            before checking whether it is empty or not. So for the case when string is of
            length 0, the below check passes and we should search history picked from local
            storage before the results served by the back-end. But for the case when the
            query is a string of non zero length but composed only of spaces the below
            check fails. Confirm with the PM if this behaviour is okay, doesn't seem to
            me(@nandwana92).
        */
        if (!autoSuggestQuery && !noASCache) {
            this.storeData = historyData.concat(this.storeData.slice(0, 10 - historyData.length + 1));
        }
        let count = this.storeData.length;
        return (<form className={cx(styles['search'], 'header-form-search')} action="/search" method="GET" onSubmit={this.handleSubmit}>
				<div className={cx('col-12-12', styles['search-ctn'])}>
					<div className={styles['txtContainer']}>
						<input value={decodedSearchTxt || ''} onChange={this.handleChange} className={styles['txtQuery']} type="text" title={hintText} ref={this.inputRef} name="q" autoComplete="off" onKeyDown={e => this.handleKeyDown(e)} onKeyUp={e => this.handleKeyUp(e, count)} onBlur={this.handleBlur} onFocus={this.handleFocus} placeholder={hintText}/>
					</div>
					<button className={styles['btnSearch']} type="submit" data-aid="btnSearch">
						<SearchIcon width={20} height={20} pathClassName={styles['icon-search']}/>
					</button>
					<input type="hidden" name="otracker" value="search"/>
					<input type="hidden" name="otracker1" value="search"/>
					<input type="hidden" name="marketplace" value={marketplaceId}/>
					<input type="hidden" name="as-show" value={Array.isArray(this.storeData) && count > 0 ? 'on' : 'off'}/>
					<input type="hidden" name="as" value="off"/>
				</div>
				<ul className={cx('col-12-12', styles['autosuggest'], { [styles['visible']]: autosuggestVisible })} onMouseOver={this.handleMouseOver}>
					{this.storeData &&
            this.storeData.map((store, index) => {
                return this.renderItem(store, index, highlightIndex, styles);
            })}
				</ul>
			</form>);
    }
}
Search.contextTypes = {
    router: PropTypes.object
};
const mapStateToProps = (state) => ({
    autosuggest: state.autosuggest,
    defaultQuery: get(state, ['pageDataV4', 'browseMetadata', 'q']) || '',
    disableSearch: get(state, ['config', 'data', 'globalConfig', 'disableSearch']) || false,
    noASCacheGlobalConfigFlag: get(state, ['config', 'data', 'globalConfig', 'noASCache']) || false
});
const mapDispatchToProps = {
    fetchAutosuggest: fetchAutosuggestAction,
    saveInHistory: saveAutosuggestItemAction,
    savePlainQuery: savePlainQueryItemAction,
    initAutoSuggest: initAutoSuggestAction,
    getAbValue: getAbValueAction
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Search));
